import Component from '@glimmer/component';
import { get } from '@ember/object';

/**
 * @param {Object<iPad|Dashboard|Passport|System>}          device
 * @param {String|Null}                                     via
 * @param {String|Null}                                     by
 * @param {String}                                          type      values [in | out] used in tests
 */
export default class SignInOutDetails extends Component {
  get viaText() {
    const via = this.args.via;
    if (!via) return '';

    const deviceName = get(this.args, 'device.displayName');
    return via === 'iPad' && deviceName ? `${via}: ${deviceName}` : via;
  }
}
